import buildOwnTemplate from "@images/all-template-banner.png";

export const REQUEST_A_TEMPLATE_URL = "https://airtable.com/shrDDbSTfYF88B13i";

export const buildOwnTemplateBannerData = {
  name: "build-own-template",
  primaryText: "Create a Template",
  description: "Don’t see what you’re looking for? You can create or ",
  ctaData: {
    ctaText: "BUILD MY OWN",
    secondaryCtaText: "request a template",
    secondaryAnchorLink: REQUEST_A_TEMPLATE_URL,
    additionalText: ".",
  },
  image: buildOwnTemplate,
};
